/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1IndividualpaymentParcelsParcelid200,
  PutApiV1IndividualpaymentParcelsParcelid400,
  PutApiV1IndividualpaymentParcelsParcelid401,
  PutApiV1IndividualpaymentParcelsParcelid500,
  PutApiV1IndividualpaymentParcelsParcelidMutationRequest,
  PutApiV1IndividualpaymentParcelsParcelidMutationResponse,
  PutApiV1IndividualpaymentParcelsParcelidPathParams,
} from "../../types/individualPaymentOperationsController/PutApiV1IndividualpaymentParcelsParcelid.ts";
import { individualPaymentParcelSaveViewModelSchema } from "../individualPaymentParcelSaveViewModelSchema.ts";

export const putApiV1IndividualpaymentParcelsParcelidPathParamsSchema =
  z.object({
    parcelId: z.coerce.number().int(),
  }) as unknown as ToZod<PutApiV1IndividualpaymentParcelsParcelidPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1IndividualpaymentParcelsParcelid200Schema =
  z.any() as unknown as ToZod<PutApiV1IndividualpaymentParcelsParcelid200>;

/**
 * @description Regra de negócio violada
 */
export const putApiV1IndividualpaymentParcelsParcelid400Schema =
  z.any() as unknown as ToZod<PutApiV1IndividualpaymentParcelsParcelid400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1IndividualpaymentParcelsParcelid401Schema =
  z.any() as unknown as ToZod<PutApiV1IndividualpaymentParcelsParcelid401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1IndividualpaymentParcelsParcelid500Schema =
  z.any() as unknown as ToZod<PutApiV1IndividualpaymentParcelsParcelid500>;

export const putApiV1IndividualpaymentParcelsParcelidMutationRequestSchema =
  z.lazy(
    () => individualPaymentParcelSaveViewModelSchema,
  ) as unknown as ToZod<PutApiV1IndividualpaymentParcelsParcelidMutationRequest>;

export const putApiV1IndividualpaymentParcelsParcelidMutationResponseSchema =
  z.lazy(
    () => putApiV1IndividualpaymentParcelsParcelid200Schema,
  ) as unknown as ToZod<PutApiV1IndividualpaymentParcelsParcelidMutationResponse>;
